import request from 'ykd-base/request'
import CouponDefine from '@/model/coupon/couponDefine'
import Coupon from '@/model/coupon/coupon'
import WxJsmp from '@/model/common/wxJsmp'

/**
 * 查询优惠卷信息
 *
 */
export async function getCoupon(
  accountId: string,
  couponDefineId: string
): Promise<CouponDefine> {
  const res = await request<CouponDefine>({
    method: 'GET',
    biz: 'done',
    url: '/coupon/get',
    params: {
      accountId: accountId,
      couponDefineId: couponDefineId
    }
  })
  return res && res.data
}
export async function getLatestCoupon(
  partnerAccountId: string,
  couponDefineId: string
): Promise<CouponDefine> {
  const res = await request<CouponDefine>({
    method: 'GET',
    biz: 'done',
    url: `/coupon/latest?partnerAccountId=${partnerAccountId}&couponDefineId=${couponDefineId}`,
  })
  return res && res.data
}
/**
 * 领取优惠卷
 *
 */
//支付
export async function receive(
  couponDefineId: string,
  partnerAccountId: string
): Promise<boolean> {
  const res = await request<boolean>({
    method: 'POST',
    biz: 'done',
    url: '/coupon/receive',
    data: {
      couponDefineId: couponDefineId,
      partnerAccountId: partnerAccountId
    }
  })
  return res.isSuccess
}
//根据状态查询优惠卷
export async function queryByStatus(
  isPartner: boolean,
  useStatus?: string
): Promise<Coupon[]> {
  const res = await request<Coupon[]>({
    method: 'GET',
    biz: 'done',
    url: '/coupon/query/status',
    params: {
      useStatus: useStatus,
      partner: isPartner
    }
  })
  return res && res.data
}
const reHost = /(\.[-\w]+\.[-\w]+)$/
const serverHost =
  (reHost.exec(window.location.hostname) || [])[1] || '.unreach.io'
//获取微信分享的配置信息
export async function requestWxConfing(url: string): Promise<WxJsmp> {
  const res = await request<WxJsmp>({
    method: 'GET',
    biz: 'member',
    url: '/share/wxjsmp',
    params: {
      url: url
    },
    withCredentials: true
  })
  return res && res.data
}

export async function queryByType(type: string): Promise<Coupon[]> {
  const res = await request<Coupon[]>({
    method: 'GET',
    biz: 'done',
    url: '/coupon/query/type',
    params: {
      type: type
    }
  })
  return res && res.data
}
//根据优惠卷id查询优惠卷
export async function getCouponById(couponId: string): Promise<Coupon> {
  const res = await request<Coupon>({
    method: 'GET',
    biz: 'done',
    url: '/coupon/get/id',
    params: {
      couponId: couponId
    }
  })
  return res && res.data
}

export async function getCommission(): Promise<number> {
  const res = await request<number>({
    method: 'GET',
    biz: 'done',
    url: '/coupon/get/commission'
  })
  return res && res.data
}
